import React from "react";
import LeadCaptureForm from "../components/LeadCaptureForm";

const HeroResultBanner = () => {
  const results = [
    { label: "+11% Capital Growth", detail: "in 6 Months", image: "/ravi.webp" },
    { label: "+6.5% Rental Yield", detail: "High Return Suburb", image: "/deepak.jpg" },
    { label: "+$150K Equity", detail: "in 12 Months", image: "/gopi.webp" },
    { label: "Positive Cashflow", detail: "From Day 1", image: "/Tarragona.jpg" },
    { label: "Undermarket Deal", detail: "Secured Below Valuation", image: "/undermarket.jpg" },
    { label: "Offmarket", detail: "Secured Before Hitting Market", image: "/offmarket_mohan.webp" },
  ];

  return (
    <section className="bg-white pt-16 pb-4 px-6 text-center">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-between gap-10">
        
        {/* LEFT SIDE: TEXT + FORM */}
        <div className="text-left max-w-xl w-full">
          <h1 className="text-4xl md:text-5xl font-bold text-[#003366] leading-tight mb-4 border-b-4 border-[#fbb40b] inline-block pb-2">
            Buy Smarter. Grow Faster.
          </h1>
          <p className="text-[#003366] text-lg mb-6">
           From search to settlement — we’ve got your back.
          </p>
          <div className="mb-12">
            <LeadCaptureForm />
          </div>
        </div>

        {/* RIGHT SIDE: IMAGE GRID - Hidden on Mobile */}
        <div className="w-full max-w-xl flex-col gap-4 hidden lg:flex">
          <div className="grid grid-cols-2 gap-4">
            {results.map((r, i) => (
              <div key={i} className="relative overflow-hidden rounded-lg shadow-md">
                <img
                  src={r.image}
                  alt={r.label}
                  className="w-full h-40 object-cover brightness-75"
                />
                <div className="absolute bottom-2 left-2 text-white text-sm font-semibold drop-shadow">
                  {r.label}
                  <div className="text-xs font-normal">{r.detail}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default HeroResultBanner;
